export function goToURL(url, newTab = false) {
    if (newTab) {
        // Abre la URL en una nueva pestaña
        window.open(url, '_blank');
    } else {
        // Redirige a la URL en la misma pestaña
        window.location.href = url;
    }
}